import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
const data = [{
  initials: 'ML',
  quote: 'Mi hija ahora me pide «mamá, ¿hacemos una cita hoy?»… No tiene precio.',
  name: 'María L.',
  location: 'Buenos Aires',
  role: 'Mamá de 2 hijos'
}, {
  initials: 'LR',
  quote: 'Nos devolvió momentos que la rutina nos estaba robando. Ahora tenemos nuestro ritual familiar.',
  name: 'Lucas R.',
  location: 'Córdoba',
  role: 'Papá de familia'
}, {
  initials: 'CS',
  quote: 'Abro el libro, elijo una cita y listo. Sin planificar nada. Mis hijos lo esperan cada día.',
  name: 'Carolina S.',
  location: 'Mendoza',
  role: 'Mamá de 3 hijos'
}];
export function Testimonials1() {
  return <TestimonialsSection title="💬 FAMILIAS QUE YA ESTÁN CREANDO RECUERDOS" testimonials={data} data-id="element-239" />;
}